import Component from "@glimmer/component";
import md5 from "md5";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { number, string } from "prop-types";

import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

@forbidExtraArgs
export default class GravatarImage extends Component {
  @arg(string) email;

  @arg(string) fallback = "blank";

  @arg(number) size = 32;

  get src() {
    return `//www.gravatar.com/avatar/${md5(this.email || "")}?d=${encodeURIComponent(this.fallback)}&s=${this.size}`;
  }

  get fallbackStyle() {
    if (this.fallback !== "blank") {
      return "";
    }

    return `bg-[url('/assets/images/user.svg')]`;
  }

  get altText() {
    return this.email || "";
  }

  <template>
    <img
      class="{{this.fallbackStyle}} bg-contain bg-no-repeat"
      data-test-gravatar-image={{this.email}}
      alt="{{this.altText}}"
      src="{{this.src}}"
      height={{this.size}}
      width={{this.size}}
      {{mergeClasses}}
      ...attributes
    />
  </template>
}
